import { useContext, createContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
const AuthContext = createContext();

function getCookie(name) {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
        cookie = cookie.trim();
        if (cookie.startsWith(name + '=')) {
            try {
                return JSON.parse(cookie.substring(name.length + 1));
            } catch (err) {
                return cookie.substring(name.length + 1);
            }
        }
    }
    return null;
}

const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(sessionStorage.getItem('user') || getCookie('user') || null);

    const navigate = useNavigate();
    const loginAction = async (provider, formData, callbackUrl) => {
        const email = formData.get("email");
        const password = formData.get("password");
        const remember = formData.get("remember");

        try {
            //TODO Delete after login backend implemented;
            const res = await axios.post('/auth/login', {
                email,
                password,
                remember
            });

            if (res.status !== 200)
                return {
                    type: 'CredentialsSignin',
                    error: 'Invalid credentials.',
                }

            setUser(res.data.user);

            sessionStorage.setItem("user", JSON.stringify(res.data.user));

            if (remember) {
                const date = new Date();
                date.setTime(date.getTime() + res.data.tokenAge);
                const userCookie = `user=${JSON.stringify(res.data.user)};expires=${date.toUTCString()};path=/;SameSite=None;Secure;`;
                document.cookie = userCookie;
            }
            navigate("/");
        } catch (err) {
            if (err.status === 401)
                return {
                    type: 'CredentialsSignin',
                    error: 'Invalid credentials.',
                }

            console.error(err);
            return {
                error: 'Trouble connecting to the server.',
            }
        }
    };

    const signOut = async () => {
        await axios.post('/auth/signout');
        sessionStorage.removeItem("user");
        setUser(null);
        navigate("/");
        return;
    };

    return (
        <AuthContext.Provider value={{ user, loginAction, signOut }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthProvider;

export const useAuth = () => {
    return useContext(AuthContext);
};